import HowDidYouHearModal from './HowDidYouHearModal';

export default HowDidYouHearModal;


// WEBPACK FOOTER //
// ./src/components/HowDidYouHearModal/index.jsx